import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
  standalone: false,
  selector: 'bringoz-tooltip',
  templateUrl: './bringoz-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozTooltipComponent implements AfterViewInit {
  @Input() content: string;
  @Input() placement: string = 'top';
  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;

  ngAfterViewInit() {
    this.tooltipTrigger.nativeElement.setAttribute('data-toggle', 'tooltip');
    this.tooltipTrigger.nativeElement.setAttribute('data-trigger', 'hover');
    this.tooltipTrigger.nativeElement.setAttribute('data-html', 'true');
    this.tooltipTrigger.nativeElement.setAttribute('data-placement', this.placement);
  }
}
